import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { installLatinNumerals } from "./lib/latinNumerals";

installLatinNumerals();

// ─── CSRF Token initialisation ────────────────────────────────────────────
// Generate a per-session CSRF token on first load and store in sessionStorage.
// The centralized apiClient (lib/api.js) injects this as X-CSRF-Token.
(function initCSRF() {
  if (!sessionStorage.getItem("csrfToken")) {
    try {
      const arr = new Uint8Array(32);
      crypto.getRandomValues(arr);
      const token = Array.from(arr, (b) =>
        b.toString(16).padStart(2, "0"),
      ).join("");
      sessionStorage.setItem("csrfToken", token);
    } catch (e) {
      // crypto not available (very old browser) — skip
    }
  }
})();

// ─── React root ───────────────────────────────────────────────────────────
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
